import Url from 'url-parse'

const functions = {
  // Get domain name
  getDomainName: function () {
    return typeof window !== 'undefined' && window.location && window.location.host ? window.location.host : ''
  },

  // Get website protocol
  getWebSiteProtocol: function () {
    return typeof window !== 'undefined' && window.location && window.location.protocol ? window.location.protocol : ''
  },

  // Get website url
  getWebsiteUrl: function (helpCenterPage) {
    const url = new Url(helpCenterPage)
    if (url && url.protocol && url.hostname) {
      return `${url.protocol}//${url.hostname}/`
    }

    return ''
  },

  // Get help center url
  getHelpCenterUrl: function (paths, currentUrl) {
    const currUrl = currentUrl || `${window.location.origin}${window.location.pathname}`
    const newPathsArray = currUrl.split('/')
    let url = '/'
    let index = 0
    const urlLimit = newPathsArray[1].length === 2 ? 3 : 2
    newPathsArray.forEach((path) => {
      if (index < urlLimit && path.trim() !== '') {
        url = `${url}${path}/`
        index++
      }
    })

    // search page
    if (currUrl.indexOf(`/${paths.search}`) !== -1) {
      return `${currUrl.substring(0, currUrl.indexOf(`/${paths.search}`))}`
    } else {
      // return `/${newPathsArray.join("/")}/`;
      return `${url}`
    }
  },

  // Strip HTML tags
  stripHTMLTags: function (html) {
    if (html) {
      return html.replace(/(<([^>]+)>)/gi, '')
    }
    return ''
  },

  // clean Query string
  cleanQueryString: function (query) {
    return encodeURIComponent(query)
    // return query.split(/[:/?#@!$&'()*+,;=]/g).join("").split(/["<>%{}|\^`]/g).join("").split(" ").join("+");
  },

  // getSearchPath
  getSearchUrl: function (url) {
    const paths = url.split('/')
    const searchPath = paths[paths.length - 2]
    return searchPath
  },

  // getFullPath
  getFullPathUrl: function (paths, contentPath, helpCenterPath) {
    let cleanContentPath = contentPath
    if (cleanContentPath.substr(-1) === '/') {
      cleanContentPath = cleanContentPath.substr(0, cleanContentPath.length - 1)
    }
    return `${this.getHelpCenterUrl(paths, helpCenterPath)}${cleanContentPath}/`
  },
}

export default functions
